'use client';

import { useMediaQuery } from '@react-hookz/web';

import { DEFAULT_BREAKPOINTS } from './constants';

export function useBreakpointUp(query: keyof typeof DEFAULT_BREAKPOINTS) {
    return Boolean(useMediaQuery(`only screen and (min-width : ${DEFAULT_BREAKPOINTS[query]})`));
}
